import { Card, Layout, Result } from "antd";

export const PendingApprovalPage = () => (
  <Layout
    style={{
      minHeight: "100dvh",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--ant-color-bg-layout)",
    }}
  >
    <Card style={{ width: 480 }}>
      <Result
        status="info"
        title="Awaiting approval"
        subTitle="Your single sign-on account was created but still needs an Owner to approve it
        before you can sign in. You'll receive access once an Owner assigns a role to your
        account."
      />
    </Card>
  </Layout>
);
